import { Grid, TextField } from "@material-ui/core";
import { DesktopDatePicker } from "@material-ui/lab";
import cx from "classnames";
import { useField } from "formik";
import React from "react";

const EntryDate = ({
  required,
  label,
  topLabel,
  name,
  inputFormat = "dd/MM/yyyy",
  minDate = new Date("2021-11-02"),
  // ...
  xs = 12,
  md = 6,
}) => {
  const [field, meta, helpers] = useField({ name });
  // ...
  return (
    <Grid item xs={xs} md={md}>
      {topLabel && (
        <label
          style={{
            display: "block",
            color: "#333",
            fontFamily: "Poppins, sans-serif",
            fontSize: "13px",
            lineHeight: "20px",
            fontWeight: "500",
            margin: "0 0 5px 0",
          }}
        >
          {topLabel}
        </label>
      )}
      <DesktopDatePicker
        label={label}
        name={name}
        value={field.value}
        onChange={(date) => helpers.setValue(date)}
        inputFormat={inputFormat}
        minDate={minDate}
        // ...
        renderInput={(params) => (
          <TextField
            className={cx("Entry EntryTime", { __required: required })}
            {...params}
            // ...
            error={!!meta.error}
            helperText={meta.error}
            // ...
            // helperText={null}
            fullWidth
            margin="normal"
          />
        )}
      />
    </Grid>
  );
};

export default EntryDate;
